import { createContext } from 'react';

export const GoogleMapContext = createContext({});
